import { matchRoutes, Outlet, useLocation } from 'react-router-dom';
import { Tabs } from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';

export const UserAccountSettings = () => {
  const location = useLocation();
  const { t } = useTranslation(['common']);
  const secondaryNavigation = [
    {
      name: t('Personal Settings'),
      to: '/user/home/settings',
      current: !!matchRoutes(
        [
          {
            path: '/user/settings',
          },
        ],
        location
      ),
    },
    {
      name: t('Delete Account'),
      to: '/user/home/settings/delete',
      current: !!matchRoutes(
        [
          {
            path: '/user/settings/delete',
          },
        ],
        location
      ),
    },
    {
      name: t('Notifications'),
      to: '/user/home/settings/notifications',
      current: !!matchRoutes(
        [
          {
            path: '/user/settings/notifications',
          },
        ],
        location
      ),
    },
    {
      name: t('Billing'),
      to: '/user/home/settings/billing',
      current: !!matchRoutes(
        [
          {
            path: '/user/settings/billing',
          },
        ],
        location
      ),
    },
  ];

  return (
    <div>
      <main className="p-10 bg-white rounded-2xl shadow">
        <Tabs tabs={secondaryNavigation} />
        <Outlet />
      </main>
    </div>
  );
};

export default UserAccountSettings;
